import React, { useEffect, useState } from "react";
import PartnerCompany from "../../../../AllPageComponents/PartnerCompany/PartnerCompany";
import FAQ from "../../../../AllPageComponents/FAQ/FAQ";
import { Link } from "react-router-dom";
import FastImage from "../../../../FastImage";
import { auto } from "@patternfly/react-core/dist/esm/helpers/Popper/thirdparty/popper-core";
import Redirect from "../../../../AllPageComponents/Rederict";
import { Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import { MdOutlineExpandMore } from "react-icons/md";
import { IoMdAddCircle } from "react-icons/io";
import { Helmet } from "react-helmet-async";

const CashlessHealthTreatment = () => {
  const initialText =
    "With Beema1, get top-rated health insurance plans online. You can compare online and buy the most suitable insurance plan for you and your family. You can also get your queries answered by our team of experts.";

  const [showFullText, setShowFullText] = useState(false);

  const toggleShowFullText = () => {
    setShowFullText(!showFullText);
  };

  const [Readmore, setReadmore] = useState(true);

  const HandelReadmore = () => {
    setReadmore(!Readmore);
  };

  const [Readmoretwo, setReadmoretwo] = useState(true);

  const HandelReadmoreTwo = () => {
    setReadmoretwo(!Readmoretwo);
  };
  const [expanded, setExpanded] = useState(null);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : null);
  };

  const [proscons, setproscons] = useState(1);

  const [isHidden, setisHidden] = useState(true);
  const handelHidden = () => {
    setisHidden(!isHidden);
  };

  const [readmoreclame, setreadmoreclame] = useState(false);
  const handelclame = () => {
    setreadmoreclame(!readmoreclame);
  };

  const HowToBuyHealthInsurence = [
    {
      step: 1,
      title: "Provide Your Details",
      description:
        "Enter your information to get instant access to competitive insurance quotes. Easily compare insurance policy premiums from the top-rated insurers.",
    },
    {
      step: 2,
      title: "Compare Quotes & Select The Right Health Insurance Plan",
      description:
        "Compare plans based on features and costs aligned with your needs, and your budget, and then choose the best-fit plan for yourself.",
    },
    {
      step: 3,
      title: "Pay and Get Policy Within Minutes",
      description:
        "Buy your policy online and receive it instantly in your mail inbox.",
    },
    {
      step: 4,
      title: "Get Your Policy",
      description:
        "Get your policy – Once you make the payment towards your insurance policy, your policy will be issued immediately in no time, only if there are no underwriting requirements.",
    },
    {
      step: 5,
      title: "Constant Customer Support",
      description:
        "Our customer service team is dedicated to helping you with any queries.",
    },
  ];

  const [hide, sethide] = useState(false);

  const hidestatus = () => {
    sethide(!hide);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section className="car-insurance insurance-all main-health  mainnargin-insurance">
        <div className="container">
          <Redirect />
          <div className="row insurance-row-one">
            <div className="col-sm-12 col-md-4 col-lg-4 mian-one ">
              <div className="healthdiscription">
                {/* <h1>Understanding Cashless Health Insurance</h1> */}
                <h1>
                  Top cashless health insurance Know more on cashless hospitals
                </h1>
                <div>
                  <span style={{ textAlign: "justify" }}>{initialText}</span>
                </div>
              </div>
              <div className="insurance-btn-set">
                <button
                  type="button"
                  className="reminderbutton"
                  data-toggle="modal"
                  data-target="#reminderpopup"
                >
                  {" "}
                  <svg
                    stroke="currentColor"
                    fill="none"
                    strokeWidth={2}
                    viewBox="0 0 24 24"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fontSize="15pt"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{ color: "rgb(251, 167, 27)", margin: "0px 5px" }}
                  >
                    <circle cx={12} cy={13} r={8} />
                    <path d="M12 9v4l2 2" />
                    <path d="M5 3 2 6" />
                    <path d="m22 6-3-3" />
                    <path d="M6.38 18.7 4 21" />
                    <path d="M17.64 18.67 20 21" />
                  </svg>{" "}
                  Set Reminder
                </button>
              </div>
            </div>
            <div className="col-sm-12 col-md-4 col-lg-4 side-image">
              <FastImage
                url={
                  "Website%20Img/mascot_image1678942204.png?updatedAt=1718776425936"
                }
                width={auto}
                height={auto}
                alt={"arrow"}
                src={
                  "Website%20Img/mascot_image1678942204.png?updatedAt=1718776425936"
                }
              />
            </div>
            <div className="col-sm-12 col-md-4 col-lg-4 popup-main">
              <div className="form-main">
                <form id="insurance_form_get_plan">
                  <div className="d-flex align-items-center form-input">
                    <h1>
                      Compare &amp; Buy Customized Health Plans starting at just
                      <span className="specialprice">Rs ₹257/month*</span>
                    </h1>
                    <div className="blue-btn">
                      <Link to={"/healthStep1"}>
                        <button
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                            color: "white",
                            fontWeight: 400,
                          }}
                        >
                          Get Your Quotes
                        </button>{" "}
                        <img alt="" src="" className="" />
                      </Link>
                    </div>
                    <p className="insurance-text-light">
                      By clicking, I agree to{" "}
                      <a href="/termsandcondition">*terms &amp; conditions</a>{" "}
                      and <a href="/privacy-policy">privacy policy</a>.
                    </p>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="inbulitmargine"></div>

      <div className="fixwidthDivtext">
        <div className="container">
          <h1 className="healthHeading">
            Comparing Reimbursement vs Cashless in Health Insurance Plans
          </h1>
          <div className="yellowline"></div>
          <div className="row">
            <div className="col-md-12">
              <div className={Readmore ? "Readmore" : "Readless"}>
                <span className="textformat">
                  We generally say, “Health is Wealth”. Like economic erosion in
                  our financial status, our health condition also gets depleted
                  warning us with many such signs. As a result, unfortunately we
                  start facing dual issues, one is financial and the other one
                  is core health issues. Hence, your health complications lead
                  us to several hospitalizations, which demand for financial
                  requirements and medical treatments that weakens our financial
                  standpoint. Thus, people opt for Health Insurance plans.
                  There’s a constant debate in your subconscious mind about
                  which option is better and wiser to go for - Reimbursement or
                  Cashless. This is what makes all the difference during the
                  claim process. While in many cases at the time of
                  hospitalization in non-partner hospitals, there is no option
                  other than going for the reimbursement process, but in certain
                  cases, there are options to select that the insured individual
                  gets to make. Since availing of the best health insurance
                  plans, it is a pivotal step towards protecting one’s financial
                  backups during the time of severe ailments, such decisions
                  must be taken only after carefully considering both the
                  options: reimbursement and cashless, having a clearer
                  understanding of the differences between the two. When you buy
                  a Mediclaim policy, the insurance company might offer you the
                  option to choose the facility of cashless claims. This means
                  you do not need to pay anything for your medical treatments or
                  hospital fees at the hospitals because those hospitals are
                  registered under the insurance company as the network
                  hospitals. Instead, in this scenario the insurance company
                  will directly handle those expenses. To use cashless
                  mediclaim, the patient must be admitted to one of the network
                  hospitals. These hospitals have legal agreements with
                  insurance companies to offer cashless treatments to the
                  policyholders. Once everything is verified, policyholders can
                  get approval to avail cashless claims, following the policy's
                  terms and conditions.
                </span>

                <p className="textformat">
                  <span className="qustionTag">
                    CASHLESS CLAIM IN HEALTH INSURANCE -{" "}
                  </span>
                  The cashless procedure of repaying in health insurance plans
                  is when the insured person can offer their health insurance ID
                  after hospitalization or any medical treatments and the health
                  insurer pays off the billed amount to the hospital directly.
                  In this case, the insured individual need not pay out of their
                  pockets, provided they haven’t exceeded their room rent
                  restrictions or their billed amount hasn’t surpassed the sum
                  insured, or they don’t have a copayment clause in their
                  policy.Cashless claim settlement provides you the benefit of
                  treatment at network hospitals without any upfront payment or
                  after the treatment. The hospital will directly send the bill
                  to the insurer, and they will settle it without you having to
                  pay from your pocket. Choosing a cashless claim procedure is
                  much quicker, easier, and requires less documentation
                  processing it faster. The main magic is to choose an insurer
                  that covers this without hassle. However, this can only be
                  claimed or expected only in-network hospitals, for the
                  calculable future. The government is sincerely bringing this
                  facility to non-network hospitals, but it would be a time
                  consuming matter to materialize.
                  <p className="qustionTag">
                    When do you avail the option and what is the time span for
                    processing the claim settlement?
                  </p>
                  <p>
                    In case of partner hospitals only, the cashless repayment
                    process in health insurance plan requires the submission of
                    medical bills, and verifications regarding the same from the
                    health insurer’s end or from the end of the Third Party
                    Administrator (TPA ). Since there's no role of insured
                    individuals in the cashless mode, the whole claim settlement
                    process is much quicker and convenient.
                  </p>
                  <p className="qustionTag">
                    How does the claim process work in the cashless mode?
                  </p>
                  <p className="textformat">
                    An insured individual informs the health insurance provider
                    about an immediate hospitalization in a network facility.
                    Submit the health e-card and insurance policy number to the
                    hospital desk. Fill up the insurance form and submit it
                    either to your TPA or directly to the insurer.
                    Post-generation of the hospital invoice, the health insurer
                    will be informed about the bill generated and the amount
                    will be settled by the provider. In case of cashless mode,
                    the insurer/TPA needs to be informed beforehand, preferably
                    within 72 hours. In case of emergency hospitalization, the
                    approval for the cashless claim needs to be made within 24
                    hours of hospitalization.
                    <br />
                    <i>
                      Example - Anjali has a health insurance policy from one of
                      the leading insurers from India with multiple renowned
                      hospitals in its network.
                    </i>
                    &nbsp; One day, Anjali experienced a sudden stomach ache and
                    was hurried to the nearest hospital for further diagnosis.
                    She had to undergo a list of clinical tests, acknowledging
                    the requirement for an urgent colonoscopy. Her family had
                    provided her health insurance card to the hospital help desk
                    and asked for a cashless claim settlement as per her policy
                    terms and conditions. The hospital, registered as the
                    insurer's network hospital, informed the insurer about
                    Anjali’s uncertain hospitalization and the treatment she
                    underwent during her hospitalization.The hospital directly
                    contacted the insurer, and the medical bill was settled in
                    no time. This relieved Anjali to concentrate purely on her
                    recovery with absolutely no worries about medical treatment
                    costs.
                  </p>
                </p>

                <p className="textformat">
                  <h4 className="healthHeading">
                    Reimbursement In Health Insurance
                  </h4>
                  <div className="yellowline"></div>
                  Reimbursement in health insurance policy is when the
                  policyholder pays their hospital bills or any medical bills
                  out of their pocket at the beginning, and later on raises a
                  claim with their insurance provider to disburse the claim
                  amount to their account. When this option is provided and
                  what’s the time period for processing the claim settlement ?
                  <br />
                  In case of both partner and non-partner hospitals,
                  reimbursement in health insurance plans involve a long list of
                  documentations and submission of documents, and
                  cross-verification of the same process with the concerned
                  hospital authority. The process is carried with no serious
                  time-bound restrictions and limitations considering that the
                  insured individual has already cleared the bill out of their
                  pocket. The claim settlement process is extended. The
                  policyholder offers a statement about the hospitalization to
                  the insurance provider or the TPA during or immediately after
                  the treatment is completed. He/She pays off the hospital bill
                  from their own pocket.
                </p>
              </div>
              <div className="redbtn">
                <button onClick={HandelReadmore} className="Readmorebtn">
                  {Readmore ? "Read more" : "Read Less"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="fixwidthDivtext">
        <div className="container">
          <h1 className="healthHeading">
            How Can Beema1 Help to Choose a Cashless Health Insurance Policy?
          </h1>
          <div className="yellowline"></div>
          <div className="row">
            <div className="col-md-6 d-flex justify-content-center align-items-center">
              <p className="textformat" style={{ textAlign: "justify" }}>
                Beema1 simplifies the complex task of comparing insurance by
                providing helpful advice with the best guidance and assistance
                in finding the right cashless health insurance policy. You will
                just have to enter a few basic details such as name, age, annual
                income, etc. on Beema1.com to receive quotes on health insurance
                for free. Over and above, you can compare health policies from
                different insurance providers on the online platform of
                Beema1.com, to make sure you secure the right and the most
                suitable coverage for yourself and your family.
              </p>
            </div>
            <div className="col-md-6 d-flex justify-content-center align-items-center">
              <FastImage
                url="/Website%20Img/customer-service_2593468.png?updatedAt=1729841078864"
                className="fmailimagegifs"
                width={auto}
                height={auto}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="fixwidthDivtext">
        <div className="container">
          <h1 className="healthHeading">
            Claim Process For Reimbursement In Health Insurance
          </h1>
          <div className="yellowline"></div>
          <div className="row">
            <div className="col-md-12">
              <p className="textformat">
                Collect all the bills and invoices for the treatment being done
                and later submit all the documents to the insurance provider.
                Fill in the necessary health insurance form. Time to wait for
                the provider/TPA to complete the verification process of all the
                details with the network/non-network hospital desk and then
                reimburse the billed amount. Considering the insured individual
                is confirmed that the medical treatment he/she will undergo is
                covered by the policy he/she has availed, no prior announcement
                has to be made to the insurance company/TPA regarding the claim.{" "}
                <a onClick={hidestatus} hidden={!hide} className="linktag">
                  Read more
                </a>
                <span
                  className={hide ? "hide" : "nonhide"}
                  style={{ color: "#2959B8", fontWeight: 600 }}
                >
                  Example -
                </span>
                <p className={hide ? "hide " : "nonhide textformat"}>
                  She collected all the necessary documents from the hospital,
                  including medical reports, bills, payment receipts, discharge
                  summary, etc. Deepika submitted these documents and the
                  reimbursement claim form to the insurance provider. After
                  evaluating the documents, her insurer reviewed and processed
                  the claim, and reimbursed for the medical expenses she had
                  sustained during her treatment, minus any deductible or
                  co-payment as per her health insurance policy terms &
                  conditions. Deepika got into a dreadful accident and underwent
                  a surgery under emergency conditions. She was immediately
                  rushed to a nearby hospital, which does not fall under the
                  insurer's network. After undergoing a much needed surgery and
                  receiving necessary treatments, Deepika had to pay quite a
                  hefty amount of hospital bills out of pocket{" "}
                  <a onClick={hidestatus} hidden={hide} className="linktag">
                    {" "}
                    Read less
                  </a>
                  .
                </p>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="fixwidthDivtext">
        <div className="container">
          <h1 className="healthHeading">
            Types of Cashless Mediclaim in India?{" "}
          </h1>
          <div className="yellowline"></div>
          <div className="row">
            <div className="col-md-6 d-flex justify-content-center align-items-center">
              <div>
                <div className={readmoreclame ? "" : "redmoreclass"}>
                  <p className="textformat">
                    <span className="specialprice">
                      1. Cashless Individual Health Insurance Mediclaim:-
                    </span>
                    The individual cashless Mediclaim policy provides coverage
                    for just one person. It takes care of all the medical
                    expenses for that individual and offers the convenience of
                    cashless hospitalization.
                  </p>
                  <p className="textformat">
                    <span className="specialprice">
                      2. Cashless Family Health Insurance:-
                    </span>
                    Through this type of cashless Mediclaim policy for families,
                    you can insure your entire family under one plan for a
                    modest premium. The coverage amount for a family cashless
                    Mediclaim policy is typically higher than that of an
                    individual cashless insurance plan.
                  </p>
                  <p className="textformat">
                    <span className="specialprice">
                      3. Cashless Senior Citizen Health Insurance:-
                    </span>
                    This is another type of cashless health insurance plan that
                    offers benefits and coverage to senior citizens only.
                    According to the policy, they will receive cashless benefits
                    for ambulance expenses, hospitalization costs, and more.
                  </p>
                  <p className="textformat">
                    <span className="specialprice">
                      4. Cashless Critical Illness Insurance:-
                    </span>
                    This health insurance policy helps to cover the treatment
                    costs for serious illnesses like cancer and heart disease.
                    It provides a lump sum to cover treatment costs and focus on
                    recovery.
                  </p>
                </div>
                <div className="redbtn">
                  <button onClick={handelclame} className="Readmorebtn">
                    readmore
                  </button>
                </div>
              </div>
            </div>
            <div className="col-md-6 d-flex justify-content-center align-items-center">
              <FastImage
                url="/Website%20Img/medical-bill_18075195.png?updatedAt=1729842136058"
                width={auto}
                height={auto}
                className="fmailimagegifs"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="fixwidthDivtext">
        <div className="container">
          <h1 className="healthHeading">Pros & Cons Of The Cashless Process</h1>
          <div className="yellowline"></div>
          <div className="row">
            <div className="col-md-12">
              <p className="textformat">
                Whether you are at a partner or a non-partner hospital,
                reimbursement is anytime an option. This option is easy and
                quicker because, in any such cases of a medical emergency, one
                does not have sufficient time to look for a network hospital.
                Thus, the only option left is reimbursing the hospital invoice.
                There could be a delay in your claim settlement process. The
                reimbursement oriented mode of payment states that there’s no
                hurry to settle the claim. The cross-verification of the
                documents and invoices takes quite a long time. So, naturally,
                there is an extended time period involved.
              </p>
              <div className="prosconsdiv">
                <div
                  className={
                    proscons === 1 ? "tabsproscons" : "tabsprosconsdeactive"
                  }
                  onClick={() => {
                    setproscons(1);
                  }}
                >
                  Pros
                </div>
                {/* <span className='anclass'>&</span> */}
                <div
                  className={
                    proscons === 2 ? "tabsproscons" : "tabsprosconsdeactive"
                  }
                  onClick={() => {
                    setproscons(2);
                  }}
                >
                  Cons
                </div>
              </div>
              <div className="graybox">
                {proscons === 1 ? (
                  <>
                    <p className="textformat">
                      The claim settlement process is trouble-free. With few
                      number of parties involved, and payment within a specific
                      time frame, makes cashless mode a hassle-free claim
                      settlement procedure. This ensures one's financial
                      security by ensuring that insured people do not require
                      spending a single penny out of their savings towards
                      fulfilling health treatment requirements. After all, this
                      is the major purpose behind people taking up insurance
                      plans from the best insurance providers all across India.
                    </p>
                  </>
                ) : proscons === 2 ? (
                  <>
                    <p className="textformat">
                      During an emergency medical situation, cashless wouldn’t
                      be your option. You might be entrapped with the
                      reimbursement option considering that in a medical
                      emergency, you cannot emphasize looking for a network
                      hospital at the time of emergency medical treatments.
                    </p>

                    <p className="textformat">
                      Ask any adviser or any health insurance expert and they’ll
                      suggest that the cashless mode comes up as an indomitable
                      applicant every time, against reimbursement. It is
                      economical and financially affordable and makes sure that
                      you stay focused on recovering rather than accumulating
                      the hospital bills and invoices that will be handed over
                      to you post medical procedures. Compare and purchase best
                      health insurance plans through Beema1. Now, evidently,
                      cashless health policy is a beneficial option to have.
                      After all, the benefits that act as cushions are
                      equivalent to the reasons why initially individuals avail
                      of health insurance plans. Simultaneously, insured
                      individuals end up opting for the reimbursement option
                      despite having chosen the cashless mode.
                    </p>
                  </>
                ) : null}
                <div className={isHidden ? "hidediv" : "haddingdiv"}>
                  <p className="qustionTag">
                    Read the following case studies and observe thoroughly:
                  </p>

                  <p className="textformat">
                    <b>
                      1 &nbsp; When Does The Reimbursement Mode Of Payment
                      Become The Only Option To Opt For ? &nbsp;
                    </b>
                  </p>
                  <p className="textformat">
                    Generally, the health insurance providers prefer that you
                    inform them prior to their TPA Desk 2-3 days in advance
                    about the medical procedure that you are about to undergo.
                    Definitely, it's not possible at the time of emergency
                    situations or any hospitalization happening under
                    emergencies. But for the latter, there’s a 24 hour time span
                    to inform the health insurance provider about the emergency
                    situations. If you somehow exceed either of these
                    timeframes, insurance providers are disinclined to offer you
                    the cashless mode benefit and you are left out with only one
                    choice, i.e, reimbursement. The moment you get informed
                    about a medical procedure that you are supposed to undergo,
                    do inform your health insurance provider or TPA. In case of
                    an emergency, as soon as you get admitted to the hospital as
                    a patient or as an insured individual, go ahead and inform
                    your insurance provider. Do not forget to inform and update
                    your family and loved ones for staying prepared to take
                    required steps in case such situations ever come up, or in
                    any case you have admitted an insured individual to a
                    hospital under any emergency situation, inform the immediate
                    family members of the insured individual (patient) about the
                    incident of hospitalization.
                  </p>

                  <p className="textformat">
                    <b>
                      2 &nbsp; If The Teatment At The Commencement Procedure Is
                      Not Covered Under The Policy, But The Follow-up Ailment
                      Is.
                    </b>
                  </p>

                  <p className="textformat">
                    Multiple medical insurance policies are clubbed with certain
                    critical illness exemptions, which means they do not offer
                    coverage for certain illnesses (pre-existing diseases
                    diagnosed later). Any which ways, such existing severe
                    ailments might land you into many other serious ailments as
                    side effects of the initial medical condition. Your health
                    insurance company may offer health insurance coverages for
                    these later ailments. In such medical complexities, the
                    health insurer wants to offer only reimbursement facilities
                    as a mode of claim settlement.
                  </p>

                  <p className="textformat">
                    Opt for a health insurance policy that comes with minimum
                    exceptions in regards to offering medical insurance coverage
                    for severe illnesses and no disease-wise sub-limits. Shout
                    out for a health insurance advisor or a health insurance
                    expert who will propose plans worth catering to your current
                    health conditions and your family health history. This will
                    anytime help you avoid policies with substantial ailment
                    exceptions.
                  </p>

                  <p className="textformat">
                    <b>
                      3 &nbsp; In Case You Approach A Non-Network Hospital ?{" "}
                    </b>
                  </p>

                  <p className="textformat">
                    One of the most familiar cases for compulsory reimbursement
                    claim settlement is when an insured individual approaches a
                    non-partner hospital for medical treatments. In case of any
                    emergency, you cannot emphasize on searching for partner
                    hospitals over getting immediate medical attention. Well,
                    while choosing a health insurance provider, one of the key
                    points that you need to keep in mind is the number of
                    network hospitals that your provider has tie-ups with. The
                    quality of service enhances with a higher number of network
                    hospitals. Look into the vicinity of the partner hospitals
                    so that in case of any unforeseen emergency, you can quickly
                    get access to the nearby network medical facility and
                    utilize the perks of a cashless claim settlement. To be very
                    specific, a cashless or reimbursement process of repayment
                    aren’t the options we choose on our own. Whenever an
                    emergency medical condition arises for you, it calls for
                    making such a decision for you. However, given an option,
                    opting cashless always benefits your financial safety goals
                    by safeguarding your savings. On the top of it, the cashless
                    mode is a financial stress-reliever, because you need not
                    get stressed about the payment of hospital bills during your
                    medical emergency and can just get settled with hospital
                    treatments, and recovering.
                  </p>
                </div>

                <div className="redbtn">
                  <button onClick={handelHidden} className="Readmorebtn">
                    {isHidden ? "Read More" : "Read Less"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="fixwidthDivtext">
        <div className="container">
          <h1 className="healthHeading">
            Why Is It Important To Have A Cashless Health Policy?
          </h1>
          <div className="yellowline"></div>
          <div className="row">
            <div className="col-md-12">
              <p className="textformat">
                A cashless health policy becomes essential during medical
                emergencies, especially when you're low on cash or can't access
                the money right away. It is meant to remove the need for cash
                payments while promptly receiving medical treatments. With
                cashless health insurance, you can receive the best quality
                medical care without stressing out about paying hospital bills
                upfront.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="fixwidthDivtext">
        <div className="container">
          <h1 className="healthHeading">
            How To Avail Cashless Hospitalization During Emergency
          </h1>
          <div className="yellowline"></div>
          <p className="textformat">
            Planned hospitalization happens when you already know you’ll need to
            go to the hospital soon. If that's the case, you need to select a
            hospital that's a part of your insurance company's network to use
            cashless services. Here are the steps to follow for cashless
            hospitalization when you have already planned to go to the hospital:
          </p>
          <div className="row">
            <div className="col-md-6 d-flex justify-content-center align-items-center">
              <div className="stepper-wrapper">
                <div className="step-item">
                  <div className="step-description">
                    <div className="step-number">1</div>
                    <li className="liststyle">Select Your Hospital</li>
                  </div>
                </div>
                <div className="step-item">
                  <div className="step-description">
                    <div className="step-number">2</div>
                    <li className="liststyle">
                      Select Your Document With (Personal ID Proof)
                    </li>
                  </div>
                </div>
                <div className="step-item">
                  <div className="step-description">
                    <div className="step-number">3</div>
                    <li className="liststyle">Avail Your Treatment.</li>
                  </div>
                </div>
                <div className="step-item">
                  <div className="step-description">
                    <div className="step-number">4</div>
                    <li className="liststyle">Get Discharged Stress Free</li>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 d-flex justify-content-center align-items-center">
              <FastImage
                url="/Website%20Img/hospital_6144997.png?updatedAt=1729841420550"
                width={auto}
                height={auto}
                className="fmailimagegifs"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="fixwidthDivtext">
        <div className="container">
          <h1 className="theheadingcolor">
            How to Buy Health Insurance Plan from Beema1{" "}
          </h1>
          <div className="yellowline"></div>
          <p className="normaltext">
            In just a few clicks, you can secure your health policy with ease
            and convenience. Our streamlined online process is designed to save
            you time and effort, allowing you to compare various plans tailored
            to your needs. Whether you're looking for comprehensive coverage or
            specific benefits, our user-friendly platform makes it simple to
            find the right health insurance for you and your family. Moreover,
            our dedicated support team is here to guide you every step of the
            way, ensuring that you make informed decisions about your
            healthcare.
          </p>
          <div className="row">
            <div className="col-md-12 d-flex justify-content-center align-items-center hero-stepper">
              <FastImage
                url="/Website%20Img/25ppt%20(2).png?updatedAt=1727083979291"
                width={auto}
                height={auto}
                className="stepperimage"
              />
              {/* <div className="stepperone">
 1. &nbsp; Provide Your Details
  </div>
  <div className="steppertwo">
  2. &nbsp;Compare Quotes & Select The Right Health Insurance Plan
  </div>

  <div className="stepperthree">
 3. &nbsp; Pay and Get Policy Within Minutes
  </div>

  <div className="stepperfour">
  4. &nbsp;Get Your Policy
  </div> */}
              {/* <div className="stepperfour">
  4. &nbsp;Constant customer support
  </div> */}
            </div>

            <div className="fixwidthDivtext">
              <div className="col-md-12 d-flex justify-content-center align-items-center">
                <div>
                  <span className="normaltext">
                    Are you ready to safeguard your health and finances against
                    unexpected medical expenses? Finding the right health
                    insurance policy can be overwhelming, but with the right
                    information, you can make an informed decision.{" "}
                  </span>

                  {HowToBuyHealthInsurence.map((data) => {
                    return (
                      <Accordion
                        expanded={expanded === `panel${data.step}`}
                        onChange={handleChange(`panel${data.step}`)}
                        key={data.step}
                      >
                        <AccordionSummary
                          expandIcon={<MdOutlineExpandMore />}
                          aria-controls="panel1-content"
                          id="panel1-header"
                          className="accordingback"
                        >
                          <li className="listcol">
                            {data.step}.&nbsp;
                            {data.title}
                          </li>
                        </AccordionSummary>
                        <AccordionDetails className="AnwsarSpan">
                          {data.description}
                        </AccordionDetails>
                      </Accordion>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="fixwidthDivtext">
        <div className="container">
          <h1 className="healthHeading">
            Understand Cashless Hospitalization:-
          </h1>
          <div className="yellowline"></div>
          <div className="row">
            <div className="col-md-12">
              <p className="textformat">
                Let’s say, a health insurance policyholder falls sick and is
                admitted to a hospital for medical treatment. He has suffered
                for hospital expenses because of hospitalization.The insured
                individual can receive the hospital expense in two ways:
                cashless claim or reimbursed. Cashless claim or cashless
                facility or cashless hospitalization is a claim process where
                the health insurance company will pay the hospital bills
                directly to the insurer, and the policyholder will not need to
                pay the bill out of his own pocket. Only network hospitals can
                provide cashless claims.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="fixwidthDivtext">
        <div className="container">
          <h1 className="healthHeading">
            Things To Consider While Buying Cashless Medical Insurance
          </h1>
          <div className="yellowline"></div>
          <p className="textformat">
            Unplanned hospitalization may happen at any time as life is
            uncertain and unpredictable. Hence, we should be prepared for the
            emergencies that may occur in our lives at any point of time.
            Medical emergencies may occur suddenly and without any prior
            warning. Such as any kind of accident or heart attack. Having
            cashless medical insurance can reduce the stress in such situations.
            However, before choosing a cashless insurance policy, consider the
            following important factors.
          </p>
          <div className="row">
            <div className="col-md-6 d-flex justify-content-center align-items-center">
              <div>
                <p className="textformat">
                  <span className="specialprice"> Sum Insured:-</span>
                  When selecting a cashless health insurance policy, keep in
                  mind the maximum coverage amount. It's best to choose a plan
                  that offers enough coverage for the entire year.
                </p>
                <p className="textformat">
                  <span className="specialprice"> Waiting Period:-</span>
                  Another thing to consider is the waiting period for cashless
                  health policy claims. Opt for a plan with the shortest waiting
                  period, especially during emergencies.
                </p>

                <p className="textformat">
                  <span className="specialprice">
                    {" "}
                    Network and Non-Network Hospitals:-
                  </span>
                  While getting a health insurance policy with cashless benefits
                  is important, it is also necessary to check the list of
                  network hospitals.
                </p>

                <p className="textformat">
                  <span className="specialprice">Co-payment:-</span>
                  Co-payment means the part of medical expenses that the
                  policyholder pays from their pocket. The rest is covered by
                  the insurance company. So, it's important to pay attention to
                  the co-payment terms as well.
                </p>
              </div>
            </div>
            <div className="col-md-6 d-flex justify-content-center align-items-center">
              <FastImage
                url="/Website%20Img/medical_16199988.png?updatedAt=1729842799769"
                width={auto}
                height={auto}
                className="fmailimagegifs"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="fixwidthDivtext">
        <div className="container">
          <h1 className="healthHeading">
            Top Reasons For Claim Rejection In A Cashless Mediclaim Policy
          </h1>
          <div className="yellowline"></div>
          <div className="row">
            <div className="col-md-12">
              <p className="textformat">
                Here are some common reasons why cashless health insurance
                claims may get rejected: - You are not covered by your insurance
                company for the type of treatment you are hospitalized for. -
                You've used full sum insuard for the particular policy year. -
                The details provided in the pre-authorization form aren't enough
                to approve your claim. - There isn't enough information about
                your pre-existing condition in the pre-authorization form. -
                Pre-existing conditions were not declared while buying the
                policy.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="fixwidthDivtext">
        <div className="container">
          <h1 className="healthHeading">
            Cashless Everywhere - An Initiative By Indian Insurers
          </h1>
          <div className="yellowline"></div>
          <div className="row">
            <div className="col-md-6 d-flex justify-content-center align-items-center">
              <p className="textformat" style={{ textAlign: "justify" }}>
                General and health insurers in India now offer a "cashless
                everywhere" facility. This means policyholders can get cashless
                medical treatment at any hospital, even if it's not in their
                insurer's network. For planned treatment, inform your insurer 48
                hours before admission for cashless treatment. If you are
                admitted to the hospital under any emergency situation or
                circumstances, contact your insurer within 48 hours. This
                eliminates the need for policyholders to pay upfront for
                treatment at non-network hospitals and then seek reimbursements
                from the insurer. Before buying a cashless health insurance
                policy, the policyholders should consider a few key factors by
                understanding, comparing and reviewing all the cashless health
                insurance options presently available in the market
              </p>
            </div>
            <div className="col-md-6 d-flex justify-content-center align-items-center text-center">
              <FastImage
                url="/Website%20Img/Hospital%20building-rafiki.png?updatedAt=1727337131018"
                width={auto}
                height={auto}
                className="fmailimagegifs"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="fixwidthDivtext">
        <div className="container">
          <h1 className="healthHeading">
            Cashless Health Insurance: What Are Network And Non-Network
            Hospitals?
          </h1>
          <div className="yellowline"></div>
          <div className="row">
            <div className="col-md-12 d-flex justify-content-center align-items-center ">
              <p className="textformat">
                Your insurance company usually partners with various hospitals
                to offer cashless treatment to policyholders. These hospitals,
                known as network hospitals, have negotiated rates with the
                insurer to ensure broader coverage for policyholders.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="fixwidthDivtext">
        <div className="container">
          <h1 className="healthHeading">
            How Do Network And Non-Network Hospitals Charge?
          </h1>
          <div className="yellowline"></div>
          <div className="row">
            <div className="col-md-6 d-flex justify-content-center align-items-center">
              <FastImage
                url="/Website%20Img/Ambulance-pana.png?updatedAt=1727337681160"
                width={auto}
                height={auto}
                className="fmailimagegifs"
              />
            </div>
            <div className="col-md-6 d-flex justify-content-center align-items-center">
              <div>
                <p className="textformat">
                  It's important to know how a non-impaneled hospital will bill
                  you for treatment. In such instances, the charges are
                  typically compared to the prevailing rates in the area for the
                  type of hospital—whether it's primary, secondary, or tertiary.
                  If the hospital is already a part of another insurance
                  company's panel, the charges will be determined based on the
                  rates agreed upon with that insurer. When you visit a hospital
                  that isn't affiliated with any other insurance company (and
                  isn't blacklisted), your insurer will verify your policy
                  details and negotiate the rates directly with the non-network
                  hospital based on benchmarked rates.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="fixwidthDivtext">
        <div className="container">
          <h1 className="healthHeading">
            Do You Need To Pay Out Of Pocket At Non-Network Hospitals?
          </h1>
          <div className="yellowline"></div>

          <div className="row">
            <div className="col-md-6 d-flex justify-content-center align-items-center">
              <div>
                <p className="textformat" style={{ textAlign: "justify" }}>
                  The cost of treatment can vary depending on whether you go to
                  a network hospital or a non-network hospital. For example, if
                  your insurance covers up to Rs. 50,000 for surgery at a
                  network hospital, you'll likely receive cashless treatment
                  without any out-of-pocket expenses. However, if you opt for
                  the same surgery at a non-network hospital where the cost is
                  Rs. 70,000, the settlement of the claim will depend on your
                  policy's terms and your insurer. If the surgery cost exceeds
                  your insurance coverage, you'll need to pay the excess amount
                  out of your pocket. A network hospital could be a better
                  option if you prefer a guaranteed cashless facility without
                  any out-of-pocket expenses. Insurers often have established
                  partnerships with network hospitals, increasing the likelihood
                  of cashless facilities being accessible. Non-network hospitals
                  may decline cashless services, possibly necessitating upfront
                  payments followed by reimbursement claims.
                </p>
              </div>
            </div>
            <div className="col-md-6 d-flex justify-content-center align-items-center">
              <FastImage
                url="/Website%20Img/Doctors-bro.png?updatedAt=1727337954549"
                width={auto}
                height={auto}
                className="fmailimagegifs"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="fixwidthDivtext">
        <div className="container">
          <h1 className="healthHeading">
            Advantages Of Opting For Network Hospitals Over Non-Network
            Hospitals For Cashless Treatment
          </h1>
          <div className="yellowline"></div>
          <div className="row">
            <div className="col-md-12">
              <p className="textformat">
                <span className="specialprice">Fixed Tariffs:-</span>
                Empaneled hospitals have set tariffs agreed upon with the
                insurance provider. This removes uncertainties, ensuring medical
                procedure charges stay within a specified limit. This can lead
                to quicker discharge for customers and increased satisfaction
                for the insurance company.
              </p>
              <p className="textformat">
                <span className="specialprice">
                  Smooth Cashless Settlement:-
                </span>
                Cashless settlement processes at network hospitals are typically
                smoother and faster due to the established relationship between
                the hospital and the insurance provider.
              </p>

              <p className="textformat">
                <span className="specialprice">Quality Assurance:-</span>
                Insurance companies tie up with competent quality impaneled
                hospitals for quality standards, reducing the risk of unexpected
                complications or substandard care.
              </p>

              <p className="textformat">
                <span className="specialprice">Reduced Fraud Risk:-</span>
                Empaneled hospitals operate within a network with established
                relationships and agreements, lowering the risk of inflated
                billing or unnecessary procedures. In contrast, non-network
                hospitals may not undergo the same level of scrutiny,
                potentially resulting in higher costs and misuse of insurance
                coverage. A good health insurance policy is a financial tool
                that supports you with steadiness and stability at the time of a
                medical emergency. When you are admitted to a hospital for
                treatments, the only worry that bothers you is how your medical
                bills will be covered. With a quality health insurance policy,
                you can approach all top-rated health care facilities– including
                hospital stays, surgeries, medications, etc. at a fragmented
                cost. Whether a sudden hospitalization or a planned procedure, a
                good health insurance policy offers peace of mind that the
                insurer will settle the claim. But how does a claim is settled
                by the insurance companies ?
              </p>
            </div>
          </div>
        </div>
      </div>

      <PartnerCompany />
      <FAQ />
    </>
  );
};

export default CashlessHealthTreatment;
